import supportModule from '../../support.module';

export default supportModule.component('supportContact', {
    template: require('./supportContact.component.html'),
    styleUrls: require('./supportContact.component.css'),
    controller: [
        '$sce',
        'supportSystemService',
        'textResources',
        supportContactComponent
    ],
    bindToController: true
});

function supportContactComponent($sce, supportSystemService, textResources) {
    var vm = this;
    var trusted = {};

    vm.$onInit = init;
    function init() {
        supportSystemService.getSupportContact().then(function(contacts) {
            if (contacts.length > 0) {
                var content = `${
                    textResources.supportContactPopoverTitle
                } <ul class="phoneList">`;
                for (var index in contacts) {
                    var contact = contacts[index];
                    content += `<li><sub>${contact.region}</sub><a href="tel:${
                        contact.no
                    }">${contact.no}</a></li>`;
                }
                content += '</ul>';
                vm.input = {
                    id: 'asuiPopoverExample',
                    placement: 'top',
                    title: 'Title',
                    content: content
                };
                vm.content = vm.input.content;
            }
        });

        vm.getPopoverContent = function(content) {
            return (
                trusted[content] ||
                (trusted[content] = $sce.trustAsHtml(vm.content))
            );
        };
    }
}



// WEBPACK FOOTER //
// ./modules/support/components/support-contact/supportContact.component.js